import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=3c48f660&scoped=true"
import script from "./reset.js?vue&type=script&lang=js&external"
export * from "./reset.js?vue&type=script&lang=js&external"
import style0 from "./reset.vue?vue&type=style&index=0&id=3c48f660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48f660",
  null
  
)

export default component.exports